import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import AcaoButtons from "../../Shared/AcaoButtons";

// Etapa "Aprovação da Solicitação" da Renovação de GDM — Aprovar/Reprovar. A justificativa é
// opcional ao aprovar e obrigatória ao reprovar (mesma regra do backend).
export default function EtapaRenovacaoGdmAprovacao({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [justificativa, setJustificativa] = useState("");
    const [tentouReprovar, setTentouReprovar] = useState(false);

    function executar(acao) {
        const texto = justificativa.trim();
        if (acao === "REPROVAR" && !texto) {
            setTentouReprovar(true);
            return;
        }
        onExecutarAcao(acao, { dados: texto ? { justificativaAprovacao: texto } : {} });
    }

    return (
        <div className="flex flex-col gap-4">
            <div>
                <Textarea
                    label="Justificativa (obrigatória para reprovar)"
                    value={justificativa}
                    onChange={e => setJustificativa(e.target.value)}
                    rows={3}
                />
                {tentouReprovar && !justificativa.trim() && (
                    <p className="text-xs text-destructive mt-1">Informe a justificativa para reprovar a renovação.</p>
                )}
            </div>
            <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} />
        </div>
    );
}
